import { FC, PropsWithChildren, ReactElement, isValidElement } from 'react';

import { Loader } from '@hh.ru/magritte-ui-loader';
import { Text, TextProps, TextStyle, TextDynamic } from '@hh.ru/magritte-ui-typography';

import styles from './cell-text.less';

type TextType = 'title' | 'subtitle' | 'description';

type CellTextCommonProps = PropsWithChildren<{
    /** Стиль текста */
    style?: TextProps['style'];
    /** Максимальное кол-во видимых строк.
     * Текст, который не поместился, будет обрезан до `...`
     *
     * Если свойство не указано, то текст обрезаться не будет */
    maxLines?: number;
    'data-qa'?: string;
}>;

export type CellTextProps = CellTextCommonProps &
    (
        | {
              /** Режим отображения, задает стилизацию */
              type?: 'title' | 'description';
              showLoader?: never;
              icon?: never;
          }
        | {
              type?: 'subtitle';
              /** Флаг показа лоадера, доступен только при type="subtitle" */
              showLoader?: boolean;
              icon?: ReactElement;
          }
    );

const TextDefaultStyleMap: Record<TextType, TextStyle> = {
    title: 'primary',
    subtitle: 'secondary',
    description: 'tertiary',
};

export const CellText: FC<CellTextProps> = ({
    showLoader = false,
    style,
    type = 'title',
    'data-qa': dataQa = 'cell-text',
    maxLines,
    children,
    icon,
}) => {
    const typography = type === 'title' ? 'label-2-regular' : 'label-3-regular';
    const textStyle = style || TextDefaultStyleMap[type];

    if (!children) {
        return null;
    }

    return (
        <div className={styles.container} data-qa={dataQa}>
            {showLoader && !isValidElement(icon) && <Loader />}
            {isValidElement(icon) && icon}
            <TextDynamic>
                <div className={styles.text} style={{ WebkitLineClamp: maxLines || 'none' }}>
                    <Text typography={typography} style={textStyle}>
                        {children}
                    </Text>
                </div>
            </TextDynamic>
        </div>
    );
};
